import { useState } from "react";
import { toast } from "sonner";
import { Send, Loader2, Unplug, Radar } from "lucide-react";
import { apiGet, apiPost } from "@/lib/api";
import axios from "axios";
import { API, authHeader } from "@/lib/api";

export const TelegramPanel = ({ settings, onChanged }) => {
  const [chatId, setChatId] = useState("");
  const [loading, setLoading] = useState(false);
  const connected = settings?.telegram_chat_id;

  const detect = async () => {
    setLoading(true);
    try {
      const { data } = await apiGet("/telegram/detect");
      toast.success(`Terhubung ke @${data.username || data.chat_id}`);
      onChanged?.();
    } catch (e) {
      toast.error("Deteksi gagal", { description: e.response?.data?.detail });
    } finally {
      setLoading(false);
    }
  };

  const connect = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await apiPost("/telegram/connect", { chat_id: chatId });
      toast.success("Telegram terhubung — pesan uji terkirim");
      onChanged?.();
    } catch (e2) {
      toast.error("Gagal menghubungkan", { description: e2.response?.data?.detail });
    } finally {
      setLoading(false);
    }
  };

  const disconnect = async () => {
    await axios.delete(`${API}/telegram`, { headers: authHeader() });
    toast.success("Telegram diputus");
    onChanged?.();
  };

  const test = async () => {
    try {
      await apiPost("/notify/telegram", {});
      toast.success("Ringkasan sinyal terkirim ke Telegram Anda");
    } catch (e) {
      toast.error("Gagal mengirim", { description: e.response?.data?.detail });
    }
  };

  return (
    <div className="max-w-2xl border border-white/10 bg-[#0d1219] p-6" data-testid="telegram-panel">
      <div className="flex items-center justify-between">
        <h3 className="font-display text-lg font-bold text-white">Notifikasi Telegram</h3>
        {connected && (
          <span className="border border-buy/50 bg-buy/10 px-2.5 py-1 font-mono text-[10px] font-bold text-buy" data-testid="telegram-status">
            TERHUBUNG
          </span>
        )}
      </div>

      {connected ? (
        <div className="mt-4 space-y-3 font-mono text-xs">
          <p className="text-mute">Chat ID: <span className="text-white">{connected}</span> · bot @nakedchartai_bot</p>
          <p className="text-mute-dim">Sinyal TRADE baru, posisi dibuka/ditutup, dan batas risiko akan dikirim otomatis.</p>
          <div className="flex gap-2">
            <button onClick={test} data-testid="telegram-test-button"
              className="flex items-center gap-2 border border-buy bg-buy/10 px-4 py-2 font-bold text-buy transition-colors hover:bg-buy hover:text-ink">
              <Send size={13} /> KIRIM UJI
            </button>
            <button onClick={disconnect} data-testid="telegram-disconnect-button"
              className="flex items-center gap-2 border border-sell/40 px-4 py-2 font-bold text-sell transition-colors hover:bg-sell hover:text-white">
              <Unplug size={13} /> PUTUS
            </button>
          </div>
        </div>
      ) : (
        <div className="mt-4 space-y-4">
          <ol className="space-y-1.5 font-mono text-xs leading-relaxed text-mute">
            <li>1. Buka Telegram → cari <span className="font-bold text-white">@nakedchartai_bot</span></li>
            <li>2. Kirim pesan <span className="font-bold text-white">/start</span> ke bot</li>
            <li>3. Kembali ke sini → klik Deteksi Otomatis</li>
          </ol>
          <div className="flex flex-wrap gap-2">
            <button onClick={detect} disabled={loading} data-testid="telegram-detect-button"
              className="flex items-center gap-2 border border-buy bg-buy/10 px-4 py-2.5 font-mono text-xs font-bold text-buy transition-colors hover:bg-buy hover:text-ink disabled:opacity-60">
              {loading ? <Loader2 size={13} className="animate-spin" /> : <Radar size={13} />} DETEKSI OTOMATIS
            </button>
          </div>
          <form onSubmit={connect} className="flex gap-2">
            <input value={chatId} onChange={(e) => setChatId(e.target.value)} placeholder="atau isi chat ID manual"
              data-testid="telegram-chatid-input"
              className="h-10 flex-1 border border-white/15 bg-ink px-3 font-mono text-xs outline-none focus:border-buy/60" />
            <button type="submit" disabled={loading || !chatId} data-testid="telegram-connect-button"
              className="border border-white/20 px-4 font-mono text-xs font-bold text-mute transition-colors hover:text-white disabled:opacity-50">
              HUBUNGKAN
            </button>
          </form>
        </div>
      )}
    </div>
  );
};
